import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, from, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IAuthProvider } from '../../domain/providers/auth.provider';
import { IAccountInfo } from '../../domain/models/auth-session.model';
import { ILogoutResponse } from '../../domain/interfaces/logout.interface';
import { AuthMappers } from '../mappers/auth.mappers';

@Injectable()
export class MsalAuthProvider implements IAuthProvider {
  constructor(private readonly msalService: MsalService) {}

  initialize(): Promise<void> {
    return this.msalService.instance.initialize();
  }

  getCurrentAccount(): IAccountInfo | null {
    const accounts = this.msalService.instance.getAllAccounts();

    if (!accounts?.length) return null;

    return AuthMappers.toAccountInfoModel(accounts[0]);
  }

  logout(): Observable<ILogoutResponse> {
    return from(this.msalService.logout()).pipe(
      map(() => ({
        success: true,
        message: 'Logout exitoso',
      })),
      catchError((error) => {
        console.error('Error en logout:', error);
        return throwError(() => error);
      }),
    );
  }

  isAuthenticated(): boolean {
    const accounts = this.msalService.instance.getAllAccounts();
    return accounts.length > 0;
  }
}
